/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { OrganizationUnitFormData } from "~/views/businessContexts/OrganizationUnitForm";
import { TemporaryOrgUnit, EditData } from "../types";

type State = {
  showForm: boolean;
  formEditMode: boolean;
  isModalConfirmOpen: boolean;
  initialValues: OrganizationUnitFormData;
  tempOrgUnitData: TemporaryOrgUnit;
};

export const initialState = {
  showForm: false,
  formEditMode: false,
  isModalConfirmOpen: false,
  initialValues: {
    contactId: "",
    name: "",
    typeId: "",
  },
  tempOrgUnitData: {},
};

export enum ACTION {
  ADD = "ADD",
  EDIT = "EDIT",
  REMOVE = "REMOVE",
  CLOSE_FORM = "CLOSE_FORM",
  CLOSE_MODAL = "CLOSE_MODAL",
}

type Action =
  | {
      type: ACTION.ADD;
      payload: {
        parentNid: string;
      };
    }
  | {
      type: ACTION.CLOSE_FORM;
    }
  | {
      type: ACTION.CLOSE_MODAL;
    }
  | {
      type: ACTION.EDIT;
      payload: {
        data: EditData;
      };
    }
  | {
      type: ACTION.REMOVE;
      payload: {
        nid: string;
        name: string;
      };
    };

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case ACTION.ADD:
      return {
        ...state,
        showForm: true,
        initialValues: { name: "", typeId: "" },
        tempOrgUnitData: {
          parentNid: action.payload.parentNid,
        },
      };
    case ACTION.EDIT: {
      const { nid, parentNid, ...formValues } = action.payload.data;

      return {
        ...state,
        formEditMode: true,
        showForm: true,
        tempOrgUnitData: {
          nid,
          parentNid,
        },
        initialValues: formValues,
      };
    }
    case ACTION.REMOVE:
      return {
        ...state,
        isModalConfirmOpen: true,
        tempOrgUnitData: {
          name: action.payload.name,
          nid: action.payload.nid,
        },
      };
    case ACTION.CLOSE_FORM:
      return {
        ...state,
        showForm: false,
        formEditMode: false,
        tempOrgUnitData: {},
      };
    case ACTION.CLOSE_MODAL:
      return {
        ...state,
        isModalConfirmOpen: false,
        tempOrgUnitData: {},
      };

    default:
      throw new Error("Unknown action type");
  }
}
